export enum RcCompanyAdditionalCover {
  LEGAL_PROTECTION = 'LEGAL_PROTECTION',
  CYBER = 'CYBER',
  OBJECTS = 'OBJECTS',
}

export const getRcCompanyAdditionalCoverLabel = (
  cover: RcCompanyAdditionalCover
) => {
  switch (cover) {
    case RcCompanyAdditionalCover.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case RcCompanyAdditionalCover.CYBER:
      return $localize`Cyber risques`;
    case RcCompanyAdditionalCover.OBJECTS:
      return $localize`Objets travaillés`;
    default:
      return '';
  }
};
